import { useSortable } from '@dnd-kit/sortable';

const DragHandle = ({ id }: { id: number }) => {
  const { attributes, listeners } = useSortable({ id });

  return (
    <div
      {...attributes}
      {...listeners}
      style={{ cursor: 'move' }}
      title="Drag to reorder"
    >
      {/* <span>☰</span> */}
      {/* <i className="bx bx-move-vertical"></i> */}
      <i
        className="bx bx-grid-small text-muted"
        style={{ fontSize: '2rem' }}
      ></i>
    </div>
  );
};
export default DragHandle;
